export default "__VITE_ASSET__CIElq7NY__"